import { LOCAL_STORAGE } from "../Constant/constant";

const getData = (key: string) => {
  try {
    const item = localStorage.getItem(key);

    return item ? JSON.parse(item) : null;
  } catch (error) {
    console.log(error);
    return null;
  }
};

const setData = (key: string, value: object | string) => {
  try {
    if (value) {
      localStorage.setItem(key, JSON.stringify(value));

      return true;
    }

    return false;
  } catch (error) {
    console.log(error);
    return false;
  }
};

const removeData = (key: string) => {
  try {
    localStorage.removeItem(key);

    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

const removeAllData = () => {
  try {
    const isSSOLogin = Storage.getData(LOCAL_STORAGE.IS_SSO_LOGIN);
    localStorage.clear();

    console.log("isSSOLogin", isSSOLogin);

    if (isSSOLogin) {
      Storage.setData(LOCAL_STORAGE.IS_SSO_LOGIN, isSSOLogin);
    }
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

const Storage = {
  getData,
  setData,
  removeData,
  removeAllData,
};

export default Storage;
